function injectStyle (ssrContext) {
  require("!!../../../node_modules/_extract-text-webpack-plugin@2.1.2@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/_vue-loader@13.0.2@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-8a55193a\",\"scoped\":true,\"hasInlineConfig\":true}!../../../node_modules/_vue-loader@13.0.2@vue-loader/lib/selector?type=styles&index=0!./OrderPurchaseDone.vue")
}
var normalizeComponent = require("!../../../node_modules/_vue-loader@13.0.2@vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader!../../../node_modules/_vue-loader@13.0.2@vue-loader/lib/selector?type=script&index=0!./OrderPurchaseDone.vue"
/* template */
import __vue_template__ from "!!../../../node_modules/_vue-loader@13.0.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-8a55193a\",\"hasScoped\":true}!../../../node_modules/_vue-loader@13.0.2@vue-loader/lib/selector?type=template&index=0!./OrderPurchaseDone.vue"
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8a55193a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/customer/OrderPurchaseDone.vue
// module id = 200
// module chunks = 0